// extracted by mini-css-extract-plugin
module.exports = {"inboxRow":"inbox_inboxRow__D0_KA","singleLineText":"inbox_singleLineText__vcXcB"};